module.exports = __webpack_public_path__ + "static/media/fengniaoIcon.f268f6cb.svg";